module.exports = __webpack_public_path__ + "525b13720883d5b9fdd27d12aad6ff44.svg";